import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import PublicLayout from "../components/PublicLayout";
import { api } from "../lib/api";
import { useT } from "../lib/i18n";
import { Clock, MapPin, Sparkles } from "lucide-react";

export default function Tours() {
  const t = useT();
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/tours").then(r=>setItems(r.data)).catch(()=>{}); }, []);
  return (
    <PublicLayout>
      <section className="max-w-7xl mx-auto px-4 pt-10 pb-16">
        <div className="text-xs uppercase tracking-widest text-[#ea580c] font-semibold">{t("tours.eyebrow")}</div>
        <h1 className="text-4xl sm:text-5xl lg:text-6xl font-display font-black tracking-tight">{t("tours.title")}</h1>
        <p className="text-slate-600 mt-4 max-w-2xl">{t("tours.subtitle")}</p>
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 mt-10">
          {items.map(tour => (
            <Link to={`/tours/${tour.id}`} key={tour.id} className="group relative overflow-hidden rounded-2xl bg-white border border-slate-200 hover:-translate-y-1 hover:shadow-xl transition-transform" data-testid={`tour-item-${tour.id}`}>
              <div className="aspect-[4/3] overflow-hidden relative">
                <img src={tour.poster_url} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300" alt={tour.title} />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent" />
                {tour.badge && <div className="absolute top-3 left-3 bg-[#ea580c] text-white text-xs px-2.5 py-1 rounded-full font-semibold">{tour.badge}</div>}
                <div className="absolute bottom-3 left-3 right-3 text-white">
                  <div className="font-display font-bold text-lg leading-tight">{tour.title}</div>
                  <div className="text-xs opacity-80">{tour.subtitle}</div>
                </div>
              </div>
              <div className="p-5">
                <div className="flex items-center gap-3 text-xs text-slate-600 flex-wrap">
                  <span className="inline-flex items-center gap-1"><Clock className="w-3 h-3" /> {tour.days}D · {tour.nights}N</span>
                  <span className="inline-flex items-center gap-1"><MapPin className="w-3 h-3" /> {tour.destination}</span>
                  {tour.with_stay ? <span className="text-emerald-600">✓ {t("tours.stay_incl")}</span> : <span className="text-slate-500">{t("tours.no_stay")}</span>}
                </div>
                {tour.starts_on && <div className="text-xs text-slate-500 mt-2">{t("tours.departs")}: {tour.starts_on} · {t("tours.ends")}: {tour.ends_on}</div>}
                <div className="mt-4 flex items-end justify-between">
                  <div>
                    <div className="text-xs text-slate-500">{t("tours.per_person")}</div>
                    <div className="text-2xl font-black text-[#1e1b4b]">₹{tour.price_per_person.toLocaleString()}</div>
                  </div>
                  <span className="text-[#ea580c] font-semibold text-sm">{t("tours.view_enquire")} →</span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </section>
    </PublicLayout>
  );
}
